import React from "react";
import { AlertBlock } from "../AlertBlock";
import { useAccountGate } from "./AccountGateProvider";

export const AccountGate: React.FC = ({ children }) => {
  const status = useAccountGate();

  if (status.error) {
    return (
      <AlertBlock
        data-testid="AccountGate__Error"
        messages={[status.error?.message]}
        title={status.error?.title}
        variant="error"
        isClosable={false}
        p={3}
      />
    );
  }

  if (!status.isAccessible) {
    return (
      <AlertBlock
        data-testid="AccountGate__Info"
        variant="info"
        messages={[status.info?.message]}
        isClosable={false}
        p={3}
      />
    );
  }

  return <>{children}</>;
};
